export function sanitizeString(
  value?: string,
  options?: { lowerCase?: boolean },
) {
  if (!value) return '';

  let string = value.toString();

  if (options?.lowerCase) {
    string = string.toLowerCase();
  }

  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
